import { memo } from 'react';

import Playlists from './Playlists';
import VodVideo from './VodVideo';

import type { Bucket } from '@shared-types/uefatv.types';
import { BucketType } from '@shared-types/uefatv.types';

const Mapping = {
  [BucketType.PLAYLISTS]: Playlists,
  [BucketType.VOD_VIDEO]: VodVideo,
} as const;

const BucketComponent = ({ bucket }: { bucket: Bucket }) => {
  const Component = Mapping[bucket.type];
  if (!Component) return null;

  return <Component bucket={bucket} />;
};

const Buckets = ({ buckets }: { buckets: Bucket[] }) => {
  if (!buckets?.length) return null;

  return (
    <div>
      {buckets.map((bucket) => (
        <div key={`bid_${bucket.exid}`} id={`bid_${bucket.exid}`} className='pk-my--xl pk-my-sm--xl2'>
          <BucketComponent bucket={bucket} />
        </div>
      ))}
    </div>
  );
};

export default memo(Buckets);
